import { useQuery } from '@tanstack/react-query'

import { QUERY_KEYS } from '@/lib/queryKeys'

import { getUserById } from '../userService'

export const useUser = (userId: string) => {
  return useQuery({
    queryKey: [QUERY_KEYS.USER, userId],
    queryFn: () => getUserById(userId),
    enabled: !!userId,
  })
}
